'use strict';

import React, { Component } from 'react';

import { GenericErrorScreen } from 'com-gyf-webcore-userinterfacecomponents';
import MessagePopup from '../../../Packages/SharedComponents/Com.Gyf.WebCore.MessagePopup';

import UsuarioLoginDetalle from './UsuarioLoginDetalle.jsx';
import UsuarioSeguridadDetalle from './UsuarioSeguridadDetalle.jsx';

class VistaDeUsuario extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const selectedUserId = this.props.match.params.id;
        this.props.getData(selectedUserId, this.props.currentScope);
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    render() {
        let component = null;
        let spinner = null;

        if (this.props.data.isFetching == true)
            spinner = <div className="loading" />

        if (this.props.data.functions != undefined) {
            let functions = this.props.data.functions;

            if (functions.Consulta == true) {
                if (this.props.data.usuario == undefined)
                    return spinner;

                component = (
                    <div className="container-fluid concierge">
                        {spinner}
                        {/*POP UP*/}
                        {/*<MessagePopup isHidden={routeState.message == undefined}
                            message={routeState.message}
                            classMessage={routeState.class} />*/}

                        <UsuarioLoginDetalle
                            currentUser={this.props.data.currentUser}
                            functions={this.props.data.functions}
                            usuario={this.props.data.usuario}
                            estadoActual={this.props.data.estadoActual}
                            setUserState={this.props.setUserState}
                            setMotivoBloqueo={this.props.setMotivoBloqueo}
                            ingresaMotivoBloqueado={this.props.data.ingresaMotivoBloqueado}
                        />
                        <br />
                        <UsuarioSeguridadDetalle
                            functions={this.props.data.functions}
                            usuario={this.props.data.usuario}
                            perfiles={this.props.data.perfiles}
                            permisos={this.props.data.permisos}
                            permisosParaMostrar={this.props.data.permisosParaMostrar}
                            modoExclusivo={this.props.data.modoExclusivo}
                            accesosSimultaneos={this.props.data.accesosSimultaneos}
                            ultimoIngreso={this.props.data.ultimoIngreso}
                            ingresaMotivoBloqueado={this.props.data.ingresaMotivoBloqueado}
                            estadoActual={this.props.data.estadoActual}
                            configuracionPwType={this.props.data.configuracionPwType}
                            gruposWindows={this.props.data.gruposWindows}
                        />
                    </div>
                );
            } else {

                let values = {
                    message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
                    linkMessage: "Volver a mi pagina de inicio"
                };

                component = (
                    <div>
                        {spinner}
                        <GenericErrorScreen data={values} />
                    </div>);
            }

            return (component);
        } else {
            return spinner;
        }
    }
}

export default VistaDeUsuario;